import { NgModule,LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { SolicitudNotasIndexComponent  } from './SolicitudNotasIndex.component';
import { SolicitudNotasFormComponent } from './SolicitudNotasForm.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';
import { MatDialogModule } from '@angular/material';


const routes = [
    {
        path     : 'SolicitudNotas',
        component: SolicitudNotasIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'SolicitudNotas',
          nombreFormulario : 'SolicitudNotas'
        } 
    },
    {
        path     : 'SolicitudNotas/:formulario',
        component: SolicitudNotasFormComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'SolicitudNotas',
          nombreFormulario : 'SolicitudNotasForm'
        } 
    },
    {
        path     : 'SolicitudNotas/:cid/:formulario',
        component: SolicitudNotasFormComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'SolicitudNotas',
          nombreFormulario : 'SolicitudNotasForm'
        } 
    }
];

@NgModule({
    declarations: [
        SolicitudNotasIndexComponent,
        SolicitudNotasFormComponent
    ],
    imports     : [
        SharedModule,
        MatDialogModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        SolicitudNotasIndexComponent,
        SolicitudNotasFormComponent
    ], 
    providers: [{
      provide: LOCALE_ID,
      useValue: 'es-CO' // 'de-DE' for Germany, 'fr-FR' for France ...
    }]
})

export class SolicitudNotasModule
{
}




// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/SolicitudNotas/SolicitudNotas.module.ts